<template>
  <div id="form_anchor"></div>
<!--  <div class="hero-w">-->
<!--    <div class="hero wf-section">-->
<!--      <div class="container">-->
<!--        <div class="hh-co">-->
<!--          <h1 class="hh1 mb">Oslávte Vašu výhru s naším golfovým poistením</h1>-->
<!--          <div class="sp"></div>-->
<!--          <h2 class="hh2">Najoblúbeneišie golfové poistenie už od roku 2002 prináša istotu počas hry na Slovensku aj na cestách za golfom po celom svete.</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="hero-ac">-->
<!--        <a href="/conditions" class="btna w-inline-block">-->
<!--          <div class="mr">Mám záujem</div>-->
<!--          <div class="ico ico-r"></div>-->
<!--        </a>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="page-1">
    <div class="trv_hr">
      <div class="trv_hero_w">
        <div class="container">
          <div class="trv_hero_co"><h1 class="h1 mt-7" style="margin-top: 6.1em">Cestovné poistenie SISA Agency</h1></div>
        </div>
      </div>
    </div>
<!--  <div class="hero-w">-->
<!--    <div class="hero has-content" style="background-image: url('/img/gp/hero-6-p-1080.jpg')">-->
<!--      <div class="container">-->
<!--        <h2 class="mt-4">{{$t("home.coverage_title")}}</h2>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="hero top" style="background-image: url('/img/gp/golf_hero_1920.jpg')">-->

<!--  </div>-->
<!--  <div class="container">-->
<!--    <h2 class="mt-5 mb-5">{{$t("home.coverage_title")}}</h2>-->
<!--  </div>-->
<!--  <CoverageNew></CoverageNew>-->
    <div class="sec">
      <div class="container">
        <div class="tb_w">
          <div class="tb_23">
            <div class="mb-xl">
              <div class="rop rop-x">
                <div class="rop-t"><h4 class="h2">Rozsah poistenia</h4></div>
                <div class="rop-c">
                  <div class="rop-e ccc"><h4 class="h4">Základné</h4></div>
                  <div class="rop-b ccc"><h4 class="h4">Rozšírené</h4></div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>liečebné náklady v prípade úrazu a náhleho ochorenia akútne zubné ošetrenie<br>spoluúčasť &nbsp;0
                    €
                  </div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>50 000 &nbsp;€<br>500 &nbsp;€</div>
                  </div>
                  <div class="rop-b">
                    <div>150 000 &nbsp;€<br>1 000 &nbsp;€</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>asistenčné služby v zahraničí<br>spoluúčasť &nbsp;0 €</div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>10 000 &nbsp;€</div>
                  </div>
                  <div class="rop-b">
                    <div>30 000 &nbsp;€</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>náklady na cestu náhradného pracovníka</div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>500 &nbsp;€</div>
                  </div>
                  <div class="rop-b">
                    <div>1 500 &nbsp;€</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>cestovné výdavky pre rodinných príslušníkov poisteného pri pobyte na lôžku viac ako 7 dní</div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>500 &nbsp;€</div>
                  </div>
                  <div class="rop-b">
                    <div>1 500 &nbsp;€</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>batožina a veci osobnej potreby – krádež, strata, poškodenie<br /> limit na jednu vec<br />spoluúčasť &nbsp;0
                    €
                  </div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>500 &nbsp;€<br>100 €</div>
                  </div>
                  <div class="rop-b">
                    <div>1 500 &nbsp;€<br>300 &nbsp;€</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>zodpovednosť za škody na veciach a na zdraví tretích osôb<br />spoluúčasť &nbsp;0 €</div>
                </div>
                <div class="rop-c">
                  <div class="rop-e">
                    <div>2 000 &nbsp;€</div>
                  </div>
                  <div class="rop-b">
                    <div>15 000 &nbsp;€</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>Doba trvania 1 cesty</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>bez obmedzenia</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>Poistené činnosti</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>manuálna práca, administratívna práca, rekreačné športy, turistika</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>Nie sú poistené</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>rizikové športy, súťažné športy, chronické ochorenia, pátranie a záchrana v horách</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>Vek poistenej osoby</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>do 70 rokov</div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>Územný rozsah</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>Európa – geografické územie, okrem Slovenska, okrem krajiny kde má klient trvalý pobyta krajiny
                      ktorej je štátnym občanom
                    </div>
                  </div>
                </div>
              </div>
              <div class="rop rop_trv">
                <div class="rop-t">
                  <div>zodpovednosť za škody na veciach a na zdraví tretích osôb<br />spoluúčasť &nbsp;0 €</div>
                </div>
                <div class="rop-c">
                  <div class="rop-ec">
                    <div>bez obmedzenia</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tb_13">
            <div class="stck"><h4 class="h4 mb">Vyberte rozsah</h4>
              <div class="trf_ac_w mb-x custom-radio">
                <label class="trc_ac">
                  <input type="radio" v-model="formData.product_variant" value="basic" />
                  <div class="check check_trv">
                    <div class="check-char"></div>
                  </div>
                  <div>Základné</div>
                </label>
                <label class="trc_ac">
                  <input type="radio" v-model="formData.product_variant" value="extended" />
                  <div class="check check_trv">
                    <div class="check-char"></div>
                  </div>
                  <div>Rozšírené</div>
                </label>
              </div>
              <h4 class="h4 mb">Vyberte dĺžku</h4>
              <div class="trf_ac_w custom-radio">
                <label class="trc_ac">
                  <input type="radio" v-model="formData.duration_in_months" :value="6" />
                  <div class="check check_trv"><div class="check-char"></div></div>
                  <div>6 mesiacov</div>
                </label>
                <label class="trc_ac">
                  <input type="radio" v-model="formData.duration_in_months" :value="12" />
                  <div class="check check_trv">
                    <div class="check-char"></div>
                  </div>
                  <div>12 mesiacov</div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div id="form" class="sec">
    <div class="container">
      <div class="tb_w">
        <div class="tb_23"><h4 class="h2 mb">STORNO – zrušenie cesty</h4>
          <div class="rop rop_trv">
            <div class="rop-t">
              <div>zrušenie cesty pred odchodom<br>prerušenie cesty – predčasný návrat<br>spoluúčasť 0 €</div>
            </div>
<!--            <div class="rop-c">-->
<!--              <div class="rop-e">-->
<!--                <div>2 000 &nbsp;€</div>-->
<!--              </div>-->
<!--              <div class="rop-b">-->
<!--                <div>15 000 &nbsp;€</div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
        <div class="tb_13"><h4 class="h4 mb">Vyberte možnosť</h4>
          <div class="trf_ac_w custom-radio">
<!--            <label :class="{trc_ac: true}" >-->
<!--              <span>-->
<!--                <input type="radio" v-model="formData.trip_cancellation_coverage" :value="null">-->
<!--                Bez storna</span>-->
<!--            </label>-->
            <label :class="{trc_ac: true}">
              <span>
                <input type="radio" v-model="formData.trip_cancellation_coverage" :value="500">
                500 €</span>
            </label>
            <label :class="{trc_ac: true}">
              <span>
                <input type="radio" v-model="formData.trip_cancellation_coverage" :value="1000">
                1000&nbsp;€</span>
            </label>
            <label :class="{trc_ac: true}">
              <span>
                <input type="radio" v-model="formData.trip_cancellation_coverage" :value="1500">1&nbsp;500&nbsp;€</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec">
    <div class="container">
      <div class="trv_prc bg1">
        <div class="col-12"><h4 class="h3 fc-3">Celková cena poistenia</h4><h4 class="h2">{{ price}} €</h4>
          <div class="col-23">Vrátane dane z neživotného poistenia vo výške 8%</div>
        </div>
        <div class="col-12 ccc"><a href="/order" @click.prevent="goToForm" class="btn btn_trv w-inline-block">
          <div class="mr">Pokračovať</div>
          <div class="ico ico-r"></div>
        </a></div>
      </div>
    </div>
  </div>






  <div id="faq" class="sec wf-section bg1">
    <div class="container">
      <div class="col-13">
        <div class="stck">
          <h2 class="h2">Otázky a odpovede</h2>

        </div>
      </div>
      <div class="col-23">
        <FAQPart />
<!--        <div>-->
<!--          <div class="ml-w">-->
<!--            <div class="ml-h">-->
<!--              <div class="h4">Kde platí golfové poistenie?</div>-->
<!--              <div class="ico ml-a"></div>-->
<!--            </div>-->
<!--            <div class="ml-tg">-->
<!--              <div>Poistenie je platné na území celého sveta, vrátane Slovenskej republiky.</div>-->
<!--            </div>-->
<!--          </div>-->


<!--        </div>-->
      </div>
    </div>
  </div>
  </div>

<!--  <div class="accordion" id="parent">-->
<!--    <ItemPart :content="content" :first="index === 0" :title="title" parent-id="parent" v-for="({ title, content}, index) in data" :key="title"></ItemPart>-->
<!--  </div>-->


<!--  <div class="container mt-5">-->

<!--    <div class="row d-flex justify-content-between align-items-stretch">-->
<!--      <div class="col-md-6">-->

<!--        <CoverageTable></CoverageTable>-->
<!--      </div>-->
<!--      <div class="col-md-6 text-center d-flex flex-md-row align-items-center  justify-content-center">-->
<!--&lt;!&ndash;        <div class="price-wrap d-flex flex-column justify-content-end">&ndash;&gt;-->
<!--&lt;!&ndash;          <div class="price">&ndash;&gt;-->
<!--&lt;!&ndash;            <div class="price-title">&ndash;&gt;-->
<!--&lt;!&ndash;              {{$t('home.price_title')}}&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;            {{$t('home.price')}}&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <div class="text-start" v-html="$t('off_text')">-->

<!--        </div>-->
<!--&lt;!&ndash;        <router-link to="/order" class="btn btn-primary shadow-lg btn-lg">{{$t('home.cta')}}</router-link>&ndash;&gt;-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div class="hero mt-5" style="background-image: url('/img/gp/hero_2.png')">-->
<!--  </div>-->
<!--  <div class="container">-->
<!--    <h3 class="mt-5">{{ $t("home.faq_title") }}</h3>-->

<!--    <div class="mb-4 mt-4">-->
<!--      <FAQPart />-->
<!--    </div>-->
<!--  </div>-->


<!--  <div class="home">-->
<!--    <img alt="Vue logo" src="../assets/logo.png">-->
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--  </div>-->

</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
//import HeaderPart from "@/components/parts/HeaderPart";
//import FAQPart from "@/components/accordion/FAQPart";
//import CoverageTable from "@/components/parts/CoverageTable";
//import CoverageNew from "@/components/parts/CoverageNew";
import FAQPart from "@/components/accordion/FAQPart";
import {
  loadOrderConfiguration,
  saveOrderConfiguration,
  calculateOrderPrice,
  DEFAULT_ORDER_CONFIGURATION,
} from "@/config/orderConfiguration";

export default {
  name: 'HomeView',
  data: function (){
    return {
      formData: { ...DEFAULT_ORDER_CONFIGURATION }
    }
  },
  computed: {
    price: function () {
      return calculateOrderPrice(this.formData);
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(value) {
        saveOrderConfiguration(value);
      }
    }
  },
  mounted() {
    const stored = loadOrderConfiguration();
    if (stored) {
      this.formData = { ...this.formData, ...stored };
    }
  },
  methods: {
    goToForm: function () {
      saveOrderConfiguration(this.formData);
      this.$router.push('/order');
    }
  },
  components: {
    FAQPart,
    //CoverageNew,
    // CoverageTable,
    //FAQPart
  }
}
</script>
<style>
img{
  max-width: 100%;

}
strong{
  color: var(--main-color);
}

.trv_hr {
  position: relative;
}

.trv_hr::after {
  content: '';
  width: 100%;
  height: 30%;
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 1;
  z-index: 1;
  background-image: linear-gradient(to bottom, rgba(0,0,0,.1), rgba(0,0,30,.7));
}

.trv_hr .container {
  position: relative;
  z-index: 2;
}


/*.hero.has-content:after {*/
/*  content: '';*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  display: block;*/
/*  position: absolute;*/
/*  opacity: 1;*/
/*  z-index: 1;*/
/*  background-image: linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.0) 70%);*/
/*}*/
/*.hero .container{*/
/*  position: relative;*/
/*  z-index: 2;*/
/*}*/
/*.hero h2{*/
/*  font-size: 2.5rem;*/
/*  margin-top: 320px;*/
/*  padding-bottom: 15px;*/
/*  color: white;*/
/*}*/

.custom-radio label input[type=radio]{
  visibility: hidden;
  width: 1px;
  height: 1px;
}

.custom-radio label:has(input:not(:checked)) .check-char{
  opacity: 0;
}

.custom-radio label:has(input:checked){
  background-color: var(--blue);
}

.covering{
  font-size: 0.9em;

}
.covering td{
  padding: 5px;
}
.table td:nth-child(2){
  text-align: right;
}

.price-wrap{
  margin-right: 100px;
  /*flex: 1;*/
}
.price{
  text-align: center;
  font-size: 3em;
  color: var(--main-color);
  font-weight: bold;

}
.price-title{
  font-weight: normal;
  font-size: 0.5em;
  margin-bottom: -10px;
}
.tb_w{
  flex-wrap: wrap;
}
.tb_13{
  min-width: 320px;
}
.trv_prc.bg1{
  flex-wrap: wrap;
}
</style>
